<template>
  <div class="ws-main-bottom-nav">
    <div class="ws-main-bottom-nav__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "../assets/scss/ws-main-bottom-nav.scss";
</style>